import * as React from "react";
import {ReactElement, useEffect, useRef, useState} from "react";
import {useIntl} from "react-intl";
import {SupportedInvoiceIcons} from "../../../lib/types/types";
import {Button} from "primereact/button";
import {InvoiceService} from "../../../lib/services/invoice-service";
import {useToast} from "../../../lib/hooks/useToast";
import {supportedColors, supportedIcons} from "./invoice-icons";

interface Props {
    invoiceId: number;
    onSave: () => void;
}

export const InvoiceIconsOverlay: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const toastHelpers = useToast();

    const invoiceService = new InvoiceService(f, toastHelpers);

    const handleUpdateIcon = (icon: string, color: string) => {
        const invoiceIcon = `${icon} ${color}`;

        invoiceService.updateInvoiceIcon(props.invoiceId, invoiceIcon).then(res => {
            props.onSave();
            toastHelpers.showToast('success', f({id: 'operationSuccessful'}), '');
        }).catch(err => {

        })
    }

    const handleRemoveIcon = () => {
        invoiceService.removeInvoiceIcon(props.invoiceId).then(res => {
            props.onSave();
            toastHelpers.showToast('success', f({id: 'operationSuccessful'}), '');
        }).catch(err => {

        })
    }

    return <>
        <div className={'flex flex-column'}>
            <div className={'flex gap-2'}>
                {supportedIcons.map((icon) => (
                    <div key={icon} className={'flex flex-column gap-2'}>
                        {supportedColors.map(color => <Button key={`${icon}-${color}`} text
                                                              className={`${color} shadow-none`}
                                                              size={"large"} icon={`pi ${icon}`}
                                                              onClick={() => handleUpdateIcon(icon, color)}/>)}
                    </div>
                ))}
            </div>
            <Button severity={'danger'} label={f({id: 'reset'})} onClick={() => handleRemoveIcon()}/>
        </div>
    </>
};

